module.exports = __webpack_public_path__ + "files/f83d64a5ea4057d79d61248719254d54.svg";